import axios from "axios";
import { isMobile } from "react-device-detect";
import { generateXB3TraceID, getTMXSessionID, isSsr } from "../utils";
import { v4 as uuid } from "uuid";
import { responseErrorInterceptor } from "./interceptors";
import { REQUEST_TIMEOUT } from "../constants";

export const api = axios.create({
  // all axios can be used, shown in axios documentation
  // baseURL: getHost(),
  responseType: "json",
  timeout: 20000,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    responseErrorInterceptor(error);
    return error;
  }
);

const channelId = isMobile ? "2" : "1";

// Alter defaults after instance has been created
// instance.defaults.headers.common["Authorization"] = AUTH_TOKEN;
api.defaults.headers.common.channelId = channelId;
/* es-lint enable */
api.defaults.headers.common["Cust-Acct-Client-Delay-Token-Validation"] = 1000000;

api.defaults.headers.common["x-trace-uuid"] = uuid();

// Need to fix this to only get TMX profile ID when running in client
api.defaults.headers.common.TMXProfileID = getTMXSessionID();

/**
 * @name createRequestOptions
 * @description Helps to create request options
 * @param {optional} headers
 * @param {optional} withCredentials
 */

const createRequestOptions = (headers) => {
  const options = {};
  if (headers) {
    options.headers = headers;
  }
  options.withCredentials = true;
  return options;
};

/**
 * @name getRequest
 * @description Helps to make a get call
 * @param url - URL to make the call
 * @param headers - Optional
 */

export const getRequest = (
  url,
  data,
  headers
) => api.get(
  url,
  // $FlowFixMe
  { params: data, ...createRequestOptions(headers) }
);

/**
 * @name postRequest
 * @description Helps to make a post call
 * @param url - URL to make the call
 * @param data - Request payload
 * @param headers - Optional
 */

export const postRequest = (
  url,
  data,
  headers
  // $FlowFixMe
) => api.post(url, data, createRequestOptions(headers));

/**
 * @name putRequest
 * @description Helps to make a put call
 * @param url - URL to make the call
 * @param data - Request payload
 * @param headers - Optional
 */

export const putRequest = (
  url,
  data,
  headers
  // $FlowFixMe
) => api.put(url, data, createRequestOptions(headers));

const TMXProfileID = isSsr
  ? ""
  : window.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId();

const b2bConfig = {
  headers: {
    channelId,
    TMXProfileID,
    "X-B3-TraceId": generateXB3TraceID(),
  },
  timeout: REQUEST_TIMEOUT,
};

export const apiB2B = axios.create(b2bConfig);
